import React from 'react';
import './SocialRibbon.css';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faVimeo, faLinkedin, faSkype, faDiscord } from '@fortawesome/free-brands-svg-icons';

const SocialRibbon = ({config}) => (
  <div className="socialRibbon">
    <div className="socialLinks">
      <ul>
        { config.social.facebook &&
        <li>
          <a href={`//facebook.com/${config.social.facebook}`}><FontAwesomeIcon icon={faFacebook} /></a>
        </li>
        }
        { config.social.twitter &&
        <li>
          <a href={`//twitter.com/${config.social.twitter}`}><FontAwesomeIcon icon={faTwitter} /></a>
        </li>
        }
        { config.social.vimeo &&
        <li>
          <a href={`//vimeo.com/${config.social.vimeo}`}><FontAwesomeIcon icon={faVimeo} /></a>
        </li>
        }
        { config.social.discord &&
        <li>
          <a href={`//discord.gg/${config.social.discord}`}><FontAwesomeIcon icon={faDiscord} /></a>
        </li>
        }
        { config.social.linkedin &&
        <li>
          <a href={`//linkedin.com/${config.social.linkedin}`}><FontAwesomeIcon icon={faLinkedin} /></a>
        </li>
        }
        { config.social.skype &&
        <li>
          <a href={`//skype.com/${config.social.skype}`}><FontAwesomeIcon icon={faSkype} /></a>
        </li>
        }
      </ul>
    </div>
    <Link to="/contact" className="quoteButton">LET'S CONNECT</Link>
  </div>
);

export default SocialRibbon;
